import Joi from 'joi-browser';
import {
  EXISTANCE_EXCLUSION_FLAG,
  PENSION_VOLUNTARY_COVERAGE_FLAG,
  INSURANCE_RECEIVING_FLAG,
} from '../../../utilities/constants';
import {
  customValidateDate,
  customValidateYearMonth,
} from '../../../utilities/validateDateUtil';
import { isDayBeforeXYearsOld } from '../../../utilities/momentUtil';
import regex from '../../../utilities/validateRegex';

/**
 * バリデーション用のスキーマを作成する
 * @return {object} スキーマオブジェクト
 * */
const createValidateSchema = ({ isShowPensionExpirationDate }) => {
  const schema = Object.create(null);

  // 健康保険 加入状況
  // schema.health_insurance_flag = Joi.string().required();

  // 健康保険 特段の理由
  // schema.health_insurance_special_reason = Joi.when('health_insurance_flag', {
  //   is: EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID,
  //   then: Joi.string().required(),
  // });

  // 健康保険 保険種類
  // schema.health_insurance_type = Joi.when('health_insurance_flag', {
  //   is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
  //   then: Joi.string().required(),
  // });

  // 健康保険 健康保険者名称
  // schema.health_insurance_name_insurer = Joi.when('health_insurance_flag', {
  //   is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
  //   then: Joi.string().required(),
  // }).when('health_insurance_reason_exclusion', {
  //   is: Joi.string().valid(
  //     'けんぽ適用除外承認済',
  //     '５人未満個人事業所',
  //     '常用以外の短時間労働者',
  //     '日雇労働者',
  //     '臨時労働者',
  //     '季節的業務',
  //     '巡業・興業',
  //     '臨時的事業',
  //     '個人事業主と家族従事者',
  //     '後期高齢者医療対象者',
  //     'その他' // TODO
  //   ),
  //   then: Joi.string().required(),
  // });

  // 健康保険 適用除外理由
  // schema.health_insurance_reason_exclusion = Joi.when('health_insurance_flag', {
  //   is: EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID,
  //   then: Joi.string().required(),
  // });

  // 健康保険 被保険者番号
  schema.health_insurance_office_number = Joi.string()
    .regex(regex.pattern.integerNoSign)
    .allow(null, '');

  // 健康保険 加入予定年月
  schema.health_insurance_expected_date_of_entry = Joi.when(
    'health_insurance_flag',
    {
      is: EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID,
      then: Joi.when('health_insurance_special_reason', {
        is: '加入手続き中(確実に加入見込みあり)',
        then: customValidateYearMonth.base().validateDate(),
      }),
    }
  );

  // 健康保険 有効期限
  schema.health_insurance_expiration_date = Joi.when('health_insurance_flag', {
    is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
    then: customValidateDate.base().validateDate(),
  }).when('health_insurance_flag', {
    is: EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID,
    then: Joi.when('health_insurance_reason_exclusion', {
      is: '生活保護受給者',
      otherwise: customValidateDate.base().validateDate(),
    }),
  });

  // 健康保険 保険証
  schema.attachDocuments_HealthInsurance = Joi.when('health_insurance_flag', {
    is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
    then: Joi.array().items(
      Joi.object()
        .keys({
          file_name: Joi.string().required(),
          file_typeL: Joi.string().required(),
          file_typeS: Joi.string().required(),
          temp_file_key: Joi.string().required(),
        })
        .required()
    ),
    // .min(1)
    // .required(),
  }).when('health_insurance_reason_exclusion', {
    is: Joi.string().valid(
      'けんぽ適用除外承認済',
      '５人未満個人事業所',
      '常用以外の短時間労働者',
      '日雇労働者',
      '臨時労働者',
      '季節的業務',
      '巡業・興業',
      '臨時的事業',
      '個人事業主と家族従事者',
      '後期高齢者医療対象者',
      'その他' // TODO
    ),
    then: Joi.array().items(
      Joi.object()
        .keys({
          file_name: Joi.string().required(),
          file_typeL: Joi.string().required(),
          file_typeS: Joi.string().required(),
          temp_file_key: Joi.string().required(),
        })
        .required()
    ),
    // .min(1)
    // .required(),
  });

  // 年金 加入予定年月
  schema.pension_expected_date_of_entry = Joi.when('pension_flag', {
    is: EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID,
    then: Joi.when('pension_special_reason', {
      is: '加入手続き中(確実に加入見込みあり)',
      then: customValidateYearMonth.base().validateDate(),
    }),
  });

  // 年金 有効期限
  // 表示されてない場合はバリデーションしない
  if (isShowPensionExpirationDate) {
    schema.pension_insurance_expiration_date = customValidateDate
      .base()
      .validateDate();
  }

  // 雇用保険 加入予定年月
  schema.employment_insurance_expected_date_of_entry = Joi.when(
    'employment_insurance_flag',
    {
      is: EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID,
      then: Joi.when('employment_insurance_special_reason', {
        is: '加入手続き中(確実に加入見込みあり)',
        then: customValidateYearMonth.base().validateDate(),
      }),
    }
  );

  // 雇用保険 被保険者番号
  schema.employment_insurance_insured_number = Joi.when(
    'employment_insurance_flag',
    {
      is: EXISTANCE_EXCLUSION_FLAG.EXIST.ID,
      then: Joi.string()
        .regex(regex.pattern.hankakuIntegerSymbol)
        .allow(null, ''),
    }
  );

  // 雇用保険 有効期限
  schema.employment_insurance_expiration_date = customValidateDate
    .base()
    .validateDate();

  // 退職金共済 建退共被共済者番号
  schema.const_number = Joi.string()
    .regex(regex.pattern.hankakuIntegerSymbol)
    .allow(null, '');

  // 退職金共済 中退共契約者番号
  schema.enterprise_agreement_number = Joi.string()
    .regex(regex.pattern.hankakuIntegerSymbol)
    .allow(null, '');

  // 退職金共済 中退共被共済者番号
  schema.enterprise_insured_number = Joi.string()
    .regex(regex.pattern.hankakuIntegerSymbol)
    .allow(null, '');

  return schema;
};

/**
 * 作業員一覧 保険加入状況 タブ での安全書類項目(要入力)バリデーション
 * @return {object} バリデーション用のスキーマ
 * このプロパティ設定の並び順に従って validate が行われる
 * */
const createValidateSchemaSafetyDocItem = ({
  health_insurance_flag,
  pension_flag,
  employment_insurance_flag,
  workerBirthday,
  pension_voluntary_coverage_flag,
  pension_insurance_receiving_flag,
}) => {
  const schema = Object.create(null);

  // 健康保険 加入状況
  schema.health_insurance_flag = Joi.string().required();
  // 健康保険 加入状況が「有」の場合のみ要入力になる項目
  if (health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
    // 健康保険 健康保険種類
    schema.health_insurance_type = Joi.string().required();
  }
  // 健康保険 加入状況が「適用除外」の場合のみ要入力になる項目
  if (health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID) {
    // 健康保険 健康保険種類
    schema.health_insurance_type = Joi.string().required();
  }

  // 年金 加入状況
  schema.pension_flag = Joi.string().required();
  // 年金 加入状況が「有」の場合のみ要入力になる項目
  if (pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
    // 年金 年金種類名称
    schema.pension_type = Joi.string().required();
  }
  // 利用条件：60歳以上の場合、かつ年金 加入状況が「適用除外」の場合、かつ任意加入が「加入」の場合
  if (isDayBeforeXYearsOld(workerBirthday, 60)) {
    if (
      pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      pension_voluntary_coverage_flag ===
        PENSION_VOLUNTARY_COVERAGE_FLAG.COVERED.ID
    ) {
      // 年金 年金種類名称
      schema.pension_type = Joi.string().required();
    }
  } else {
    // 利用条件：60歳以下かつ20歳以上の場合かつ年金 加入状況が「適用除外」の場合
    if (
      pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      isDayBeforeXYearsOld(workerBirthday, 20)
    ) {
      // 年金 年金種類名称
      schema.pension_type = Joi.string().required();
    }
  }
  // 年金 受給状況
  // 利用条件：60歳以上の場合
  if (isDayBeforeXYearsOld(workerBirthday, 60)) {
    schema.pension_insurance_receiving_flag = Joi.string().required();
  }
  // 年金 任意加入
  // 利用条件：60歳以上の場合、かつ加入状況が「適用除外」の場合、かつ受給状況が「未受給」の場合
  if (
    isDayBeforeXYearsOld(workerBirthday, 60) &&
    pension_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
    pension_insurance_receiving_flag === INSURANCE_RECEIVING_FLAG.UNPAID.ID
  ) {
    schema.pension_voluntary_coverage_flag = Joi.string().required();
  }

  // 雇用保険 加入状況
  schema.employment_insurance_flag = Joi.string().required();
  if (employment_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
    // 雇用保険 被保険者種類名称
    schema.employment_insurance_type = Joi.string().required();

    // 雇用保険 被保険者番号
    schema.employment_insurance_insured_number = Joi.string().required();
  }

  // 退職金共済 中退共加入状況
  schema.enterprise_subscription_flag = Joi.string().required();

  // 退職金共済 その他退職金共済制度加入状況
  schema.other_subscription_flag = Joi.string().required();

  // 労災保険種類
  schema.worker_compensation_type = Joi.string().required();

  return schema;
};

/**
 *
 * */
const InsuranceInfoService = {
  createValidateSchema,
  createValidateSchemaSafetyDocItem,
};

export default InsuranceInfoService;



// WEBPACK FOOTER //
// ./src/services/workers/insuranceInfo/InsuranceInfoService.js